var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.snapshotSignRequest ? _c('div', [_c('time-line-item-text', {
    attrs: {
      "icon": "mdi-file-sign",
      "color": "success"
    },
    scopedSlots: _vm._u([{
      key: "text",
      fn: function fn() {
        return [_c('span', [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.$t('timeLine.ActivityTimeLineItemSnapshotSignRequest.prefix', {
              name: "<b>".concat(_vm.name, "</b>"),
              date: _vm.date
            }))
          }
        }), _vm.snapshotSignRequest && _vm.snapshotSignRequest.snapshotId ? _c('a', {
          staticStyle: {
            "margin-right": "1px"
          },
          attrs: {
            "href": "#"
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.openSnapshotSideCard.apply(null, arguments);
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemSnapshotSignRequest.resource", {
          number: _vm.snapshot.number
        })) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemSnapshotSignRequest.resource", {
          number: _vm.snapshot.number
        })) + " ")]), _vm.email ? _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.$t('timeLine.ActivityTimeLineItemSnapshotSignRequest.suffixWithEmail', {
              date: _vm.date,
              email: "<b>".concat(_vm.email, "</b>")
            }))
          }
        }) : _c('span', [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemSnapshotSignRequest.suffix")) + " ")])])];
      },
      proxy: true
    }], null, false, 288541417)
  }), _vm.isSideCardOpen && _vm.snapshot ? _c('snapshot-side-card', {
    attrs: {
      "value": _vm.snapshot
    },
    on: {
      "close": function close($event) {
        _vm.isSideCardOpen = false;
      }
    }
  }) : _vm._e()], 1) : _c('div');
}
var staticRenderFns = []

export { render, staticRenderFns }